<template>
    <div class="row gx-2">
        <div class="col-lg-3 col-sm-6 py-1" v-for="product in products" :key="product.id">
            <a :href="product.detail_url" class="item">
                <div class="image-wrap">
                    <v-lazy-image :src="product.image_url" :alt="product.name"></v-lazy-image>
                    <!--src-placeholder="/img/image-placeholder.png"-->
                    <!--<img :src="product.image_url" alt="product" loading="lazy">-->
                </div>
                <div class="text">
                    <h3>{{ product.name }}</h3>
                    <div class="actions">
                        <span class="price">
                            <span v-if="product.has_variations">od</span>
                            {{ product.main_price }}€
                        </span>
                        <span class="button sm">{{ buttonText }}</span>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        props: {
            ids: {
                required: true,
                type: Array
            },
            buttonText: {
                required: true,
                type: String
            }
        },

        data() {
            return {
                products: []
            }
        },

        created() {

            axios.post('/api/frontend/best-seller-products', {
                productsIds: this.ids
            }).then( response =>  this.products = response.data.products)
              .catch( error => console.error(error) );
        },

        components: {
            VLazyImage
        }
    }
</script>
